import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiClient from "../../config/AppAdmin";

export const fetchRiderData = createAsyncThunk(
  "waiter/fetchRiderData",  // Changed from "menu/fetchWaiterData" to "waiter/fetchWaiterData"
  async () => {
    const response = await ApiClient.get(`/orderAssign`);
    // console.log("order Assign",response);
    if (response.data) {
      return response.data; // Return the data array
    }
    throw new Error("Invalid data format");
  }
);

const orderAssignSlice = createSlice({
  name: "orderAssign",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRiderData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRiderData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRiderData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default orderAssignSlice.reducer;